import { BP, BP_WIDTH } from "@core/constants/bp";
import type { networkType, deviceType, bpType } from "@core/types/uiType";

// 현재 망 정보
export const getNetwork = () => {
  const subdomain = {
    local: ["local.", "localhost"],
    rc: ["rc.", "rc-", "rc2-"],
    sb: ["sb-", "[^.]*.sb"],
  };
  let env: networkType = "live";
  let prop: keyof typeof subdomain;

  for (prop in subdomain) {
    const matchs = subdomain[prop];
    const regexp = new RegExp(`^http[s]?:\\/\\/(${matchs.join("|")})+.*`, "i");
    if (regexp.test(window.location.href)) {
      env = prop;
    }
  }

  return env;
};

// breakpoint 가져오기
export const getBp = (w: number): bpType => {
  if (w < BP_WIDTH[BP["MD"]]) return BP["SM"];
  if (w < BP_WIDTH[BP["LG"]]) return BP["MD"];
  return BP["LG"];
};

// navigator.userAgent 기반 Device 정보 가져오기
export const getDeviceType = (): deviceType => {
  const userAgent = navigator.userAgent.toLowerCase();

  // 모바일 디바이스 체크
  const isMobile = /iphone|ipod|android|windows phone|mobile|blackberry|bb10|mini|webos|tablet/i.test(userAgent);

  // 태블릿 체크
  const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(userAgent);

  // iOS 디바이스 체크 (iPad Pro는 userAgent가 Mac으로 나옴)
  const isIOS = /iphone|ipad|ipod/i.test(userAgent);

  // iPad Pro 체크 (iPad Pro는 userAgent가 Mac으로 나오지만, touch 지원)
  const isIPadPro = isIOS && navigator.maxTouchPoints > 1;

  if (isIPadPro || isTablet) {
    return "tablet";
  }

  if (isMobile) {
    return "mobile";
  }

  return "pc";
};
